import { PageHeader } from "components/Page/PageHeader";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addPlan } from "services/planService";
import { queryClient } from "services/queryClient";
import { PlanForm } from "../form";
import { FormFields } from "../form/viewModel";
import { PLANS_QUERY_KEY } from "../viewModel";

export function NewPlan() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  async function handleSubmit(fields: FormFields) {
    toast(t("plans.add.creating_loading"), { type: "info" });
    const id = await addPlan({ ...fields });
    queryClient.invalidateQueries(PLANS_QUERY_KEY);
    toast(t("plans.add.creating_success"), { type: "success" });
    navigate(`/planos/${id}`);
  }

  return (
    <section>
      <PageHeader title={t("plans.add.title")} backPath="/planos" />
      <PlanForm
        enabled
        plan={undefined}
        onSubmit={handleSubmit}
        action={t("actions.add")}
      />
    </section>
  );
} 